import { useEffect, useState } from "react"
import FormComp from "../../../Componentes/FormComp"
import Overlay from "../../../Componentes/Overlay"
import Formulario from "../../../Componentes/Utils/Formulario"
import Modal from "../../../Componentes/Utils/Modal"
import { useModal } from "../../../contexts/ModalContext"
import axios from "axios"
import SmallLoading from "../../../Componentes/Utils/SmallLoading"

const ModalNovaArea = ({ updateAreasCatalogo }) => {

    const { closeModal } = useModal();

    const [loading, setLoading] = useState(true);

    const [formValues, setFormValues] = useState({
        centroCusto: '',
        contrato: '',
        area: ''
    })

    const [optionsObras, setOptionsObras] = useState([]);
    const [optionsContratos, setOptionsContratos] = useState([]);

    const getObras = async () => {

        setLoading(true);

        try {

            const { data } = await axios.get('https://sistemaintegrado.palmont.com.br/Painel/API/GetObrasAtivas/');

            setOptionsObras(data.map(obra => obra.OBRA));

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {

        getObras();

    }, []);

    const getContratos = async () => {

        setLoading(true);

        try {

            const { data } = await axios.post('https://sistemaintegrado.palmont.com.br/Painel/API/GetContratosObra/', {
                'centro_custo': formValues.centroCusto
            })

            setOptionsContratos(data.map(contrato => contrato.nome_contrato));

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }

    }

    useEffect(() => {

        if (formValues.centroCusto !== '') {
            getContratos();
        } else {
            setOptionsContratos([]);
        }

        setFormValues(prev => ({ ...prev, contrato: '' }));

    }, [formValues.centroCusto])

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues(prev => ({ ...prev, [name]: value }));
    }

    const handleSubmit = async (e) => {

        e.preventDefault();
        setLoading(true);

        try {

            const formData = new FormData();

            formData.append('centroCusto', formValues.centroCusto);
            formData.append('contrato', formValues.contrato);
            formData.append('area', formValues.area);

            const { data } = await axios.post('https://sistemaintegrado.palmont.com.br/Painel/API/Desvios/SaveNewArea/', formData);

            await updateAreasCatalogo();
            setFormValues(prev => ({ ...prev, area: '' }));

        } catch (error) {

            console.error(error);

        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <Overlay state={true} >
                <Modal header close={closeModal} >
                    <Formulario onSubmit={handleSubmit} >
                        <FormComp
                            title="CENTRO CUSTO"
                            type="select"
                            options={optionsObras}
                            valor={formValues.centroCusto}
                            changeFunc={handleChange}
                            name="centroCusto"
                            required
                        />
                        <FormComp
                            title="CONTRATO"
                            type="select"
                            options={optionsContratos}
                            valor={formValues.contrato}
                            changeFunc={handleChange}
                            name="contrato"
                            required
                        />
                        <FormComp
                            title="ÁREA"
                            type="text"
                            placeholder="DIGITE A ÁREA..."
                            valor={formValues.area}
                            changeFunc={(e) => setFormValues(prev => ({ ...prev, area: e.target.value.toUpperCase() }))}
                            name="area"
                            required
                        />
                        <FormComp
                            type="submit"
                            valor="SALVAR"
                        />
                    </Formulario>
                </Modal>
                {
                    loading && (
                        <Overlay state={true}>
                            <Modal size="sm" >
                                <SmallLoading />
                            </Modal>
                        </Overlay>
                    )
                }
            </Overlay>
        </>
    )
}

export default ModalNovaArea;